module.exports = __webpack_public_path__ + "/login_ui/img/cy-5322bdf84e88cc223708ea7b3daa81da.svg";